import { MailLogPage } from "../../../model/mail/MailLogPage/MailLogPage";

export const FN40S36DocumentMailLog = () => {
  return <MailLogPage type={"document"} />;
};
